export const roundNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? Math.round(parsedValue) : 0;
};

export const getRoundedDiscountPercent = (...values) => {
  const numericValues = values.map((value) => Number(value) || 0);
  return Math.max(...numericValues);
};

export const getRoundedDiscountAmount = (price, discountPercent) => {
  return roundNumber((Number(price) || 0) * (Number(discountPercent) || 0) / 100);
};

export const getRoundedSellingPrice = (price, discountPercent) => {
  const numericPrice = Number(price) || 0;
  const numericDiscountPercent = Number(discountPercent) || 0;
  return roundNumber(numericPrice - (numericPrice * numericDiscountPercent) / 100);
};
